import { Layout } from "#/common/interfaces/conversionworld/Layout";

export const LG: Layout[] = [
  { order: [], styling: [] },
  {
    order: [1],
    styling: [0],
  },
  {
    order: [1, 1],
    styling: [33, 0],
  },
  {
    order: [1, 1, 1],
    styling: [0, 33, 0],
  },
  {
    order: [1, 2, 1],
    styling: [33, 0, 33],
  },
  {
    order: [1, 2, 1, 1],
    styling: [33, 0, 66, 33],
  },
  {
    order: [1, 2, 2, 1],
    styling: [100, 66, 0, 33],
  },
  {
    order: [1, 1, 2, 2, 1],
    styling: [100, 66, 0, 66, 100],
  },
  {
    order: [1, 2, 2, 2, 1],
    styling: [133, 66, 0, 66, 33],
  },
  {
    order: [1, 2, 3, 2, 1],
    styling: [133, 66, 0, 66, 33],
  },
  {
    order: [1, 2, 3, 3, 1],
    styling: [133, 100, 33, 0, 66],
  },
  {
    order: [1, 2, 3, 3, 2],
    styling: [133, 66, 33, 0, 66],
  },
  {
    order: [1, 3, 3, 3, 2],
    styling: [133, 66, 33, 0, 66],
  },
  {
    order: [2, 3, 3, 3, 2],
    styling: [133, 66, 33, 0, 66],
  },
  {
    order: [2, 3, 3, 4, 2],
    styling: [133, 66, 33, 0, 66],
  },
  {
    order: [2, 3, 4, 4, 2],
    styling: [133, 66, 33, 0, 66],
  },
  {
    order: [2, 3, 4, 4, 3],
    styling: [133, 66, 33, 0, 66],
  },
];

export const MD: Layout[] = [
  { order: [], styling: [] },
  {
    order: [1],
    styling: [0],
  },
  {
    order: [1, 1],
    styling: [33, 0],
  },
  {
    order: [2, 1],
    styling: [33, 0],
  },
  {
    order: [2, 2],
    styling: [33, 0],
  },
  {
    order: [3, 2],
    styling: [33, 0],
  },
  {
    order: [2, 2, 2],
    styling: [66, 0, 33],
  },
  {
    order: [3, 2, 2],
    styling: [66, 0, 33],
  },
  {
    order: [3, 3, 2],
    styling: [66, 0, 33],
  },
  {
    order: [3, 3, 3],
    styling: [66, 0, 33],
  },
  {
    order: [4, 3, 3],
    styling: [66, 0, 33],
  },
  {
    order: [4, 4, 3],
    styling: [66, 0, 33],
  },
  {
    order: [4, 4, 4],
    styling: [66, 0, 33],
  },
  {
    order: [5, 4, 4],
    styling: [66, 0, 33],
  },
  {
    order: [5, 5, 4],
    styling: [66, 0, 33],
  },
  {
    order: [5, 5, 5],
    styling: [66, 0, 33],
  },
  {
    order: [6, 5, 5],
    styling: [66, 0, 33],
  },
];

export const SM: Layout[] = [
  { order: [], styling: [] },
  {
    order: [1],
    styling: [0],
  },
  {
    order: [2],
    styling: [0],
  },
  {
    order: [3],
    styling: [0],
  },
  {
    order: [4],
    styling: [0],
  },
  {
    order: [5],
    styling: [0],
  },
  {
    order: [6],
    styling: [0],
  },
  {
    order: [7],
    styling: [0],
  },
  {
    order: [8],
    styling: [0],
  },
  {
    order: [9],
    styling: [0],
  },
  {
    order: [10],
    styling: [0],
  },
  {
    order: [11],
    styling: [0],
  },
  {
    order: [12],
    styling: [0],
  },
  {
    order: [13],
    styling: [0],
  },
  {
    order: [14],
    styling: [0],
  },
  {
    order: [15],
    styling: [0],
  },
  {
    order: [16],
    styling: [0],
  },
];
